/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInUsageEntryStatus } from './linkedInUsageEntryStatus';

/**
 * One row of the LinkedIn rate-limit traffic light table.
 *
 * The ``status`` field encodes the traffic-light bucket the soft warning
 * band falls into based on Unipile's published per-action limits — see
 * ``backend/app/services/unipile/limits.py`` (Phase D).
 */
export interface LinkedInUsageEntry {
  action: string;
  used: number;
  daily_limit: number;
  status: LinkedInUsageEntryStatus;
  notes?: string;
}
